import React, { useEffect, useReducer, useState } from "react";
import TextfieldSimple from "../generalComponents/TextInputField/TextfieldSimple";
import NavBar from "../generalComponents/NavBar";
import QuilComponent from "../generalComponents/quilComponent";
import ImageUploadComponent from "../CustomerLogosPage/components/ImageUploadComponent";
import Button1 from "../UI/Button1";
import { API_ENDPOINTS } from "../config";
import { useParams, useNavigate } from "react-router-dom";
import fetch from "node-fetch";
import {
    convertHTMLListToListOfTasks,
    translateKindOfPosition,
    generateSlug,  // Consistent utility functions
    ConvertListOfTaskToHTMLList,
    translateOptionToKindOfPosition
} from "../generalComponents/UtilityFunctions/utilityFunctions";
import {IMGTYPES} from "../imgUploadConfig";

const initialState = {
    name: '',
    positionheader: '',
    img1: '',
    rtf1: '',
    img2: '',
    rtf2: '',
    buttonLink: ''
};

const reducer = (state, action) => {
    console.log("State before reducer", state);

    switch (action.type) {
        case 'SET_JOB_DATA':
            return { ...state, ...action.payload };
        case 'IMG_1':
            return { ...state, img1: action.payload.data };
        case 'IMG_2':
            return { ...state, img2: action.payload.data };
        case 'HEADER_1':
            return { ...state, positionheader: action.payload.data, name: action.payload.data };
        case 'RTF_1':
            return { ...state, rtf1: action.payload.data };
        case 'RTF_2':
            return { ...state, rtf2: action.payload.data };
        case 'LINK_1':
            return { ...state, buttonLink: action.payload.data };
        default:
            return state;
    }
};

const useFetchJobDetails = (id, lang) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchJobDetails = async () => {
                const token = localStorage.getItem('token');
                setIsFetching(true);
                try {
                    const response = await fetch(`${API_ENDPOINTS.getSingleNewJob}/${id}/${lang}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.ok) {
                        const jobData = await response.json();

                        console.log("Should fetch data for new jobForm, data => ",
                        "jobData: " ,  jobData.fieldData, " rtf2 : ", jobData.rtf2);

                        dispatch({
                            type: 'SET_JOB_DATA',
                            payload: {
                                name: jobData.fieldData.positionheader,
                                img1: jobData.fieldData.positionimage ? jobData.fieldData.positionimage.url : '',
                                img2: jobData.fieldData.companyimage ? jobData.fieldData.companyimage.url : '',
                                rtf1: jobData.fieldData.positiondescription,
                                rtf2: jobData.fieldData.companydescription,
                                positionheader: jobData.fieldData.positionheader,
                                buttonLink: jobData.fieldData.buttonlink
                            }
                        });
                    } else {
                        console.error("Failed to fetch job details");
                    }
                } catch (error) {
                    console.error('Error fetching job details: ', error);
                }
                setIsFetching(false);
            };
            fetchJobDetails();
        }
    }, [id, lang]);

    return { state, dispatch, isFetching };
};

const JobFormV2 = () => {
    const [isPending, SetIsPending] = useState(false);
    const { id, lang } = useParams();
    const navigate = useNavigate();
    const { state, dispatch, isFetching } = useFetchJobDetails(id, lang);

    const handleHeading1Change = (value) => {
        dispatch({ type: 'HEADER_1', payload: { data: value } });
    };

    const handleImageChange = (value, img_ID) => {
        dispatch({ type: `${img_ID}`, payload: { data: value } });
    };

    const handleQuilComponentChange = (value, RTF_ID) => {
        dispatch({ type: `${RTF_ID}`, payload: { data: value } });
    };
    
    const handleLinkChange = (value) => {
        dispatch({ type: `LINK_1`, payload: {data: value} });
    };

    const handleSubmit = async (event, lang) => {
        event.preventDefault();
        SetIsPending(true);
        const token = localStorage.getItem('token');
        const url = id ? `${API_ENDPOINTS.updateNewJob}/${id}/${lang}` : 
            `${API_ENDPOINTS.postNewJob}/${lang}`;

        const formData = {
            name: state.positionheader,
            positionheader: state.positionheader,
            positiondescription: state.rtf1,
            positionimage: state.img1,
            companydescription: state.rtf2,
            companyimage: state.img2,
            buttonlink: state.buttonLink,
        };

        try {
            const response = await fetch(url, {
                method : id ?'PATCH' : 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                navigate('/dashboard');
            } else {
                console.error("Failed to submit job");
            }
        } catch (error) {
            console.error('Error submitting job: ', error);
        }
        SetIsPending(false);
    };

    if (isFetching || isPending) {
        return <h1>Loading...</h1>;
    }

    return (
        <>
            <NavBar />
            <div className="flex flex-col ml-16  mt-10">
                <div className="max-w-2xl">
                    <h1 className="font-bold text-center text-2xl mb-10">Upload and Edit Jobs</h1>

                    {/* Title Image Section */}
                    <div className="mb-8">
                        <h2 className="text-lg mb-4">Titelbild</h2>
                        <div className="flex flex-col items-center">
                            <ImageUploadComponent
                                onImageUpload={(e) => handleImageChange(e, 'IMG_1')}
                                IMGTYPE={IMGTYPES.jobAdImage}
                                image={state.img1 || ''}
                            />
                            <div className="mt-4 w-full">
                                <TextfieldSimple
                                    label="Überschrift 1"
                                    OnChangeValue={(e) => handleHeading1Change(e)}
                                    value={state.positionheader}
                                />
                            </div>
                        </div>
                    </div>

                    {/* First Rich Text Editor Section */}
                    <div className="mb-8">
                        <QuilComponent
                            onStateChanged={(e) => handleQuilComponentChange(e, "RTF_1")}
                            value={state.rtf1}
                            id={1}
                        />
                    </div>

                    {/* Second Image Section */}
                    <div className="mb-8">
                        <h2 className="text-lg mb-4">Zweites Bild</h2>
                        <div className="flex flex-col items-center">
                            <ImageUploadComponent
                                onImageUpload={(e) => handleImageChange(e, 'IMG_2')}
                                IMGTYPE={IMGTYPES.jobAdImage}
                                image={state.img2 || ''}
                            />
                        </div>
                    </div>

                    {/* Second Rich Text Editor Section */}
                    <div className="mb-8">
                        <QuilComponent
                            onStateChanged={(e) => handleQuilComponentChange(e, "RTF_2")}
                            value={state.rtf2}
                            id={2}
                        /> 
                    </div>

                    {/* Button Link Section */}
                    <div className="mb-8 w-full">
                        <TextfieldSimple
                            label="Button-Link"
                            OnChangeValue={(e) => handleLinkChange(e)}
                            value={state.buttonLink}
                        />
                    </div>

                    {/* Submit/Update Button */}
                    <div className="flex mt-8 mb-8">
                        {id ? (
                            <Button1 text="Update Job" onclick={(e) => handleSubmit(e, lang)} />
                        ) : (
                            <div className="flex space-x-4">
                                <Button1 text="Submit Job DE" onclick={(e) => handleSubmit(e, 'de')} />
                                <Button1 text="Submit Job EN" onclick={(e) => handleSubmit(e, 'en')} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );

};

export default JobFormV2;
